import React from 'react';

export const AppointmentIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 20, width = 20, className = '' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 20 20"
    className={className}
  >
    <title>Appointment icon</title>
    <desc>Appointment icon</desc>
    <path
      d="M6 0v1h8V0h2v1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2V0h2Zm12 8H2v10h16V8ZM7 14v2H5v-2h2Zm4 0v2H9v-2h2Zm4 0v2h-2v-2h2Zm-8-4v2H5v-2h2Zm4 0v2H9v-2h2Zm4 0v2h-2v-2h2ZM4 3H2v3h16V3h-2v1h-2V3H6v1H4V3Z" // eslint-disable-line
      fillRule="evenodd"
    />
  </svg>
);
